// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".operationImg1{width:21px;height:21px}.right-box{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
